import store from "@/store";
import { hasFeature } from "@/security/features/featureHelper";

export function filterNavigation(items = []) {
  const session = store.state.appConfig.sessionContext;

  if (!session) {
    return [];
  }

  const permissions = session.menuPermissions || [];
  const isAdmin =
    session.idCatType === 314 &&
    store.state.appConfig.role === "BACKOFFICE" &&
    String(session.profileName || "").toLowerCase() === "backoffice";

  const recursiveFilter = (navItems) => {
    return navItems
      .filter((item) => {
        if (!item) return false;

        // Evitar items inválidos
        if (!item.title && !item.header) {
          return false;
        }

        // Admin bypass
        // if (isAdmin) {
        //   console.log("Admin bypass:", item.title);
        //   return true;
        // }

        // Feature validation
        if (item.feature && !hasFeature(item.feature)) {
          return false;
        }

        // Permission validation
        // if (item.module) {
        //   const permission = permissions.find(
        //     (p) => p.nameModule === item.module,
        //   );

        //   if (!permission?.reading) {
        //     console.log("Permission denied:", item.module);
        //     return false;
        //   }
        // }
        if (item.module) {
          const canReadModule = permissions.some(
            (p) => p?.nameModule === item.module && Boolean(p?.reading),
          );
          if (!canReadModule) {
            return false;
          }
        }

        return true;
      })
      .map((item) => {
        // if (item.children?.length) {
        //   return {
        //     ...item,
        //     children: recursiveFilter(item.children),
        //   };
        // }

        // return item;

        const nextItem =
          isAdmin && item.titleSuperAdmin
            ? { ...item, title: item.titleSuperAdmin }
            : item;
        if (nextItem.children?.length) {
          return {
            ...nextItem,
            children: recursiveFilter(nextItem.children),
          };
        }

        return nextItem;
      })
      .filter((item) => {
        if (item.children) {
          return item.children.length > 0;
        }

        return true;
      });
  };

  const result = recursiveFilter(items);
  return result;
}
